import { Link } from '@material-ui/core';
import { Link as LinkRouter } from 'react-router-dom';
import styled from 'styled-components';

export const LinkStyled = styled(Link)`
  color: ${(props) => props.theme.colors.linkLabel} !important;
`;

export const LinkRouterStyled = styled(LinkRouter)`
  color: ${(props) => props.theme.colors.linkLabel} !important;
`;